import React from 'react'
import DatePicker from 'react-datepicker'
import moment from 'moment'

interface DateOfBirthPickerProps {
  error?: boolean
  valid?: boolean
  selected?: string | Date
  onChange: (date: string) => void
}

const DateOfBirthPicker: React.FC<DateOfBirthPickerProps> = ({ error, valid, selected, onChange }) => {
  return (
    <div
      className={`input_wrapper ${error ? 'error' : ''} ${valid ? 'validated' : ''}`}
    >
      <label htmlFor="dateofbirth">Fødselsdato:</label>
      <DatePicker
        name="dateOfBirth"
        dateFormat="dd/MM/yyyy"
        className="form-control"
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        minDate={null}
        maxDate={moment().toDate()}
        selected={selected ? moment(selected).toDate() : null}
        onChange={(e) => onChange(moment(e).format('YYYY-MM-DD'))}
      />
    </div>
  )
}

export default DateOfBirthPicker
